var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-website-image"},[_c('Cards',_vm._l((_vm.files),function(file){return _c('MemberImageCard',{key:file.FileId,attrs:{"file":file}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }